var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-alert',{staticStyle:{"margin":"5px auto"},attrs:{"color":"green lighten-2","dense":"","outlined":"","type":"success","max-width":"540"}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }